
export enum ModelGroupCd {
	CENTRAL = 'Central',
	EASTERN = 'Eastern',
	WESTERN = 'Western'}

